import {makeBlobPostRequest, makePostRequest } from "./restServices";

async function fetchTreatmentReport(treatmentId: string): Promise<any> {
    try {
        const response = await makePostRequest("charts/process-treatment-report", { treatmentId });

        if (response.data.success) {
            console.log("response", response);

            return response.data;
        }

        throw new Error("Failed to fetch treatment report.");
    } catch (error) {
        console.error("Error in fetchTreatmentReport:", error);
    }
}
async function downloadReport(treatmentId: string): Promise<void> {
    try {
        const blob: Blob = await makeBlobPostRequest("charts/download-treatment-report", { treatmentId });
        // Create a URL for the Blob
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `treatment_${treatmentId}.json`;
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    } catch (error) {
        alert("File not found or could not be downloaded");
        console.error("Error in downloadReport:", error);}
}


export { fetchTreatmentReport, downloadReport };